(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_mega-menu"] && !Shopify.designMode) return;
  try {
    function initializeMegaMenu(blockId, position) {
    var desktopListItem = document.getElementById('desktop-mega-menu-list-item-' + blockId);
    var mobileListItem = document.getElementById('mobile-mega-menu-list-item-' + blockId);
    var content = document.getElementById('content-for-' + blockId);
    var desktopContentTarget = document.getElementById('MegaMenuDesktop-Content-' + blockId);
    var mobileContentTarget = document.getElementById('MegaMenuMobile-Content-' + blockId);

    // Menu desktop (barra inferior header)
    var headerMenuList = document.querySelector(
      '.header__menu-bottom .header__inline-menu > .list-menu'
    );

    if (headerMenuList && desktopListItem) {
      var desktopItem = headerMenuList.children[position - 1];
      if (desktopItem) {
        // Tomamos la etiqueta original (que ya viene traducida desde la navegación)
        var originalDesktopLabelElement =
          desktopItem.querySelector('summary span, a span, a') || desktopItem.querySelector('summary, a');
        var originalDesktopLabel = originalDesktopLabelElement
          ? originalDesktopLabelElement.textContent.trim()
          : null;

        // Conservamos la URL del ítem original de navegación para que el
        // summary del mega menú pueda redirigir al hacer click (solo desktop)
        var originalDesktopAnchor = desktopItem.querySelector(':scope > a[href]');
        var originalDesktopUrl = originalDesktopAnchor
          ? originalDesktopAnchor.getAttribute('href')
          : desktopItem.querySelector('summary[data-url]')?.dataset.url || null;

        desktopItem.replaceWith(desktopListItem);

        if (originalDesktopUrl && originalDesktopUrl !== '#') {
          var megaMenuSummary = desktopListItem.querySelector('summary');
          if (megaMenuSummary) megaMenuSummary.dataset.url = originalDesktopUrl;
        }

        // Reemplazamos el texto visible del mega menú por el texto original traducido
        if (originalDesktopLabel) {
          var newDesktopLabelElement =
            desktopListItem.querySelector('summary span') ||
            desktopListItem.querySelector('summary') ||
            desktopListItem.querySelector('a span') ||
            desktopListItem.querySelector('a');
          if (newDesktopLabelElement) {
            newDesktopLabelElement.textContent = originalDesktopLabel;
          }
        }

        if (content && mobileContentTarget && desktopContentTarget) {
          var clonedContentMobile = content.cloneNode(true);
          mobileContentTarget.appendChild(clonedContentMobile);
          desktopContentTarget.appendChild(content);
        }
      }
    }

    // Menu movil (drawer)
    var headerDrawerMenu = document.querySelector(
      'header-drawer .menu-drawer__navigation > .menu-drawer__menu'
    );

    if (headerDrawerMenu && mobileListItem) {
      var mobileItem = headerDrawerMenu.children[position - 1];
      if (mobileItem) {
        // Tomamos la etiqueta original (traducida) del drawer
        var originalMobileLabelElement =
          mobileItem.querySelector('summary, a') ||
          mobileItem.querySelector('summary span') ||
          mobileItem.querySelector('a span');
        var originalMobileLabel = originalMobileLabelElement
          ? originalMobileLabelElement.textContent.trim()
          : null;

        mobileItem.replaceWith(mobileListItem);

        // Reemplazamos el texto visible del mega menú móvil por el texto original traducido
        if (originalMobileLabel) {
          var newMobileLabelElement =
            mobileListItem.querySelector('summary') ||
            mobileListItem.querySelector('summary span') ||
            mobileListItem.querySelector('a') ||
            mobileListItem.querySelector('a span');
          if (newMobileLabelElement) {
            newMobileLabelElement.textContent = originalMobileLabel;
          }
        }

        // Re-bind events para el nuevo ítem del drawer
        var headerDrawer = document.querySelector('header-drawer');
        if (headerDrawer && typeof headerDrawer.bindEvents === 'function') {
          headerDrawer.bindEvents();
        }
      }
    }
  }

  function initializeAllMegaMenus() {
    document.querySelectorAll('.mega-menu-list-items[data-block-id]').forEach(function (el) {
      initializeMegaMenu(el.dataset.blockId, parseInt(el.dataset.position, 10) || 1);
    });
  }

  initializeAllMegaMenus();

  document.addEventListener('shopify:section:load', function (event) {
    var el = document.querySelector('.mega-menu-list-items[data-block-id="' + event.detail.blockId + '"]');
    if (el) {
      initializeMegaMenu(el.dataset.blockId, parseInt(el.dataset.position, 10) || 1);
      // Re-bind events after section reload
      setTimeout(function () {
        var headerDrawer = document.querySelector('header-drawer');
        if (headerDrawer && typeof headerDrawer.bindEvents === 'function') {
          headerDrawer.bindEvents();
        }
      }, 100);
    }
  });

  // Desktop: mega menu opens on hover (HeaderMenu in details-disclosure.js);
  // click on the summary navigates to the nav item's URL (data-url)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_mega-menu__image"] && !Shopify.designMode) return;
  try {
    // Las imagenes del mega-menu quedan con data-src (sin descargar) hasta que
  // el <details> que las contiene se abre de verdad. display:none no evita
  // la descarga por si solo, asi que se difiere con este intercambio.
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.open) return;
      details.querySelectorAll('img[data-src]').forEach(function (img) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
